import React from 'react'
import { Chip } from '@mui/material';

const RenderStatus = (status) => {
 

const chipSX = {
    height: 24,
    padding: '0 6px'
  };
  const chipNewSX = {
    ...chipSX,
    color: "#1e88e5",
    backgroundColor: "#eef2f6",
    marginRight: '5px'
  };


    const chipErrorSX = {
        ...chipSX,
        color: "#d84315",
        backgroundColor: "#fbe9e7",
        marginRight: '5px'
      };
      const chipSuccessSX = {
        ...chipSX,
        color:"#00c853",
        backgroundColor: "#b9f6ca",
        height: 28
      };
  return (
    <Chip label={status==="0"?"Pending": status==="1"?"Approved":"Rejected"}  sx={status==="0"?chipNewSX: status==="1"?chipSuccessSX:chipErrorSX} />
  )
}

export default RenderStatus